// import React, { useEffect, useState, useRef } from "react";
// import { WebService } from "../../Services/WebService";
// import AddEditAttendanceRegularization from "./AddEditAttendanceRegularization";
// import ViewRegularizationDetails from "./ViewRegularizationDetails";
// import Container from "react-bootstrap/Container";
// import { useDispatch, useSelector } from "react-redux";
// import TableComponent from "../../Services/TableComponent";
// import { PageInfo } from "../PageInfo";
// import SnackbarComponent from "../../Services/SnackbarComponent";
// import DeleteConfirmAlert from "../../Services/AlertComponent";
// import Button from "react-bootstrap/Button";
// import { NoRecordTemplate } from "../../Services/TableComponent";
// import { StandardConst } from "../../Services/StandardConst";
// import { Box } from "@mui/material";
// import BreadcrumbsComponent from "../../Services/BreadcrumbsComponent";
// import { DateTime } from "luxon";
// import { chain, map } from "underscore";
// import { useSearchParams } from "react-router-dom";
// import ActionButton from "../../Services/ActionButton";

// const AttendanceRegularizationList = () => {
//   const [searchParams] = useSearchParams();
//   const ref = useRef();
//   const refSnackbar = useRef();
//   const [records, setRecords] = useState([]);
//   const dispatch = useDispatch();

//   PageInfo({ pageTitle: "Attendance Regularization" });

//   const [permission, SetPermission] = useState({});
//   const permissionList = useSelector((s) => s.auth.PermissionList ?? []);

//   useEffect(() => {
//     SetPermission({
//       ManageAdd: true,
//       ManageEdit: true,
//       ManageView: true,
//     });
//   }, [permissionList]);

//   const fetchRegularizationList = async () => {
//     const endPoint = "AttendanceRegularization/Fetch/Own";
//     const data = await WebService({ endPoint, dispatch });
//     setRecords(
//       map(data?.AllRequests, (m) => ({
//         ...m,
//         EncodedId: window.btoa(m.RegularizationId),
//       }))
//     );
//   };

//   const onDelete = async () => {
//     await fetchRegularizationList();
//   };

//   const renderAfterCalled = useRef(false);
//   const addEditModalRef = useRef();
//   const viewDetailsModalRef = useRef();

//   useEffect(() => {
//     if (!renderAfterCalled.current) {
//       fetchRegularizationList();
//     }
//     renderAfterCalled.current = true;
//   }, []);

//   const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);

//   const viewDetails = async (id) =>
//     await viewDetailsModalRef.current.openModal(id || 0, true);

//   const fnCancel = async (id) => {
//     const data = {
//       RegularizationId: id,
//       StatusId: StandardConst.Status.Cancel,
//     };
//     await WebService({
//       endPoint: "AttendanceRegularization/ChangeStatus",
//       body: data,
//       dispatch,
//     });
//     fetchRegularizationList();
//   };

//   const getStatusBadge = (statusId) => {
//     switch (statusId) {
//       case StandardConst.Status.Applied:
//         return <span className="badge bg-warning">Pending</span>;
//       case StandardConst.Status.Approved:
//         return <span className="badge bg-success">Approved</span>;
//       case StandardConst.Status.Reject:
//         return <span className="badge bg-danger">Rejected</span>;
//       case StandardConst.Status.Cancel:
//         return <span className="badge bg-secondary">Cancelled</span>;
//       default:
//         return <span className="badge bg-info">Unknown</span>;
//     }
//   };

//   const cancelActionVisible = (request) => {
//     return request.StatusId === StandardConst.Status.Applied;
//   };

//   const columns = [
//     { Text: "EncodedId", Value: "EncodedId", isVisiable: false },
//     {
//       Text: "Request Date",
//       DateFormat: "yyyy-MM-dd",
//       Value: "RequestDate",
//     },
//     {
//       Text: "Attendance Date",
//       DateFormat: "yyyy-MM-dd",
//       Value: "AttendanceDate",
//     },
//     { Text: "Request Type", Value: "RequestTypeName" },
//     {
//       Text: "In Time",
//       Value: "CorrectedInTime",
//       render: (dr) =>
//         dr.CorrectedInTime
//           ? DateTime.fromSQL(dr.CorrectedInTime).toFormat("hh:mm a")
//           : "-",
//     },
//     {
//       Text: "Out Time",
//       Value: "CorrectedOutTime",
//       render: (dr) =>
//         dr.CorrectedOutTime
//           ? DateTime.fromSQL(dr.CorrectedOutTime).toFormat("hh:mm a")
//           : "-",
//     },
//     {
//       Text: "Status",
//       render: (dr) => getStatusBadge(dr.StatusId),
//     },
//     {
//       Text: "Approved By",
//       Value: "ApproverName",
//       render: (dr) => dr.ApproverName || "-",
//     },
//     {
//       Text: "Action",
//       cssClass: "text-center td-width-100",
//       render: (dr) => (
//         <span className="d-flex justify-align-items-center align-items-lg-center">
//           <ActionButton
//             sx={{ color: "#9A9A9A" }}
//             onClick={async () => await viewDetails(dr.RegularizationId)}
//             IconName="View"
//             id="btnView"
//           />
//           {cancelActionVisible(dr) && (
//             <>
//               <ActionButton
//                 onClick={async () => await fnEdit(dr.RegularizationId)}
//                 IconName="Edit"
//                 id="btnEdit"
//               />
//               <button
//                 className="btn btn-default mx-2"
//                 id="btnCancel"
//                 onClick={() => fnCancel(dr.RegularizationId)}
//               >
//                 <i className="fa fa-close"></i>
//               </button>
//             </>
//           )}
//         </span>
//       ),
//     },
//   ];

//   const [bData] = useState([
//     {
//       title: "Attendance Management",
//       hrefLink: "#",
//     },
//     {
//       title: "Attendance Regularization",
//       hrefLink: "#",
//     },
//   ]);

//   const MasterPageName = "Attendance Regularization";
//   const confirmMessage = MasterPageName + " Deleted successfully";
//   const AddButtonText = "Regularization Request";

//   useEffect(() => {
//     if (
//       searchParams.get("action") === "ViewDetails" &&
//       searchParams.get("search") !== null
//     ) {
//       const RegularizationId = parseInt(window.atob(searchParams.get("search")));
//       Promise.all([viewDetails(RegularizationId)]);
//     }
//   }, []);
// console.log('ab444');
//   return (
//     <>
//       <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
//       <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />

//       <Container fluid className="base-container">
//         <Box
//           sx={{
//             width: 1,
//             height: 80,
//           }}
//         >
//           <div className="d-flex justify-content-between align-items-center">
//             <div>
//               <h3 className="ms-4 mt-2">{MasterPageName}</h3>
//               <div className="ms-4">
//                 <BreadcrumbsComponent bData={bData}></BreadcrumbsComponent>
//               </div>
//             </div>
//           </div>
//         </Box>
//         <TableComponent
//           columns={columns}
//           data={chain(records)
//             .sortBy((s) => s.RegularizationId)
//             .reverse()
//             .value()}
//           title={AddButtonText}
//           isSearchRequired={true}
//           noRecordCss="p-0"
//           noRecordFound={
//             <NoRecordTemplate
//               headerValue="No Regularization Requests Found"
//               subHeaderValue="You haven't raised any attendance regularization requests yet"
//               imageUrl={StandardConst.imageNoRecordsFound}
//               actionButton={
//                 <>
//                   {permission.ManageAdd && (
//                     <Button
//                       id="NoRecordFoundRaiseRequest"
//                       variant="outline-primary"
//                       onClick={() => fnEdit(0)}
//                     >
//                       Raise {AddButtonText}
//                     </Button>
//                   )}
//                 </>
//               }
//             />
//           }
//           onAddEvent={() => fnEdit()}
//           IsAddButtonVisible={permission?.ManageAdd}
//           allowSerialNo={true}
//           initialSearchContent={searchParams.get("search") ?? ""}
//         />

//         <AddEditAttendanceRegularization
//           callBackEvent={() => fetchRegularizationList()}
//           ref={addEditModalRef}
//         />

//         <ViewRegularizationDetails
//           ref={viewDetailsModalRef}
//         />
//       </Container>
//     </>
//   );
// };

// export default AttendanceRegularizationList;

// import React, { useEffect, useState, useRef } from "react";
// import { WebService } from "../../Services/WebService";
// import AddEditAttendanceRegularization from "./AddEditAttendanceRegularization";
// import ViewRegularizationDetails from "./ViewRegularizationDetails";
// import Container from "react-bootstrap/Container";
// import { useDispatch, useSelector } from "react-redux";
// import TableComponent from "../../Services/TableComponent";
// import { PageInfo } from "../PageInfo";
// import SnackbarComponent from "../../Services/SnackbarComponent";
// import DeleteConfirmAlert from "../../Services/AlertComponent";
// import Button from "react-bootstrap/Button";
// import { NoRecordTemplate } from "../../Services/TableComponent";
// import { StandardConst } from "../../Services/StandardConst";
// import { Box } from "@mui/material";
// import BreadcrumbsComponent from "../../Services/BreadcrumbsComponent";
// import { DateTime } from "luxon";
// import { chain, map } from "underscore";
// import { useSearchParams } from "react-router-dom";
// import ActionButton from "../../Services/ActionButton";

// const AttendanceRegularizationList = () => {
//   const [searchParams] = useSearchParams();
//   const ref = useRef();
//   const refSnackbar = useRef();
//   const [records, setRecords] = useState([]);
//   const dispatch = useDispatch();

//   PageInfo({ pageTitle: "Attendance Regularization" });

//   const [permission, SetPermission] = useState({});
//   const permissionList = useSelector((s) => s.auth.PermissionList ?? []);

//   useEffect(() => {
//     SetPermission({
//       ManageAdd: true,
//       ManageEdit: true,
//       ManageView: true,
//     });
//   }, [permissionList]);

//   const fetchRegularizationList = async () => {
//     try {
//       // Correct endpoint without trailing parameters
//       const data = await WebService({ 
//         endPoint: "AttendanceRegularization/Fetch/Own",
//         method: "GET",
//         dispatch 
//       });
      
//       console.log("Full API Response:", data); // Debug log
      
//       // Handle the response structure
//       const requestsList = data?.AllRequests || data || [];
      
//       console.log("Parsed requests:", requestsList); // Debug log
      
//       setRecords(
//         map(requestsList, (m) => ({
//           ...m,
//           EncodedId: window.btoa(m.RegularizationId),
//         }))
//       );
//     } catch (error) {
//       console.error("Error fetching regularization list:", error);
//       setRecords([]); // Set empty array on error
//     }
//   };

//   const onDelete = async () => {
//     await fetchRegularizationList();
//   };

//   const renderAfterCalled = useRef(false);
//   const addEditModalRef = useRef();
//   const viewDetailsModalRef = useRef();

//   useEffect(() => {
//     if (!renderAfterCalled.current) {
//       fetchRegularizationList();
//     }
//     renderAfterCalled.current = true;
//   }, []);

//   const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);

//   const viewDetails = async (id) =>
//     await viewDetailsModalRef.current.openModal(id || 0, true);

//   const fnCancel = async (id) => {
//     const data = {
//       RegularizationId: id,
//       StatusId: StandardConst.Status.Cancel,
//     };
//     await WebService({
//       endPoint: "AttendanceRegularization/ChangeStatus",
//       body: data,
//       dispatch,
//     });
//     fetchRegularizationList();
//   };

//   const getStatusBadge = (statusId) => {
//     switch (statusId) {
//       case StandardConst.Status.Applied:
//         return <span className="badge bg-warning">Pending</span>;
//       case StandardConst.Status.Approved:
//         return <span className="badge bg-success">Approved</span>;
//       case StandardConst.Status.Reject:
//         return <span className="badge bg-danger">Rejected</span>;
//       case StandardConst.Status.Cancel:
//         return <span className="badge bg-secondary">Cancelled</span>;
//       default:
//         return <span className="badge bg-info">Unknown</span>;
//     }
//   };

//   const cancelActionVisible = (request) => {
//     return request.StatusId === StandardConst.Status.Applied;
//   };

//   const columns = [
//     { Text: "EncodedId", Value: "EncodedId", isVisiable: false },
//     {
//       Text: "Request Date",
//       DateFormat: "yyyy-MM-dd",
//       Value: "RequestDate",
//     },
//     {
//       Text: "Attendance Date",
//       DateFormat: "yyyy-MM-dd",
//       Value: "AttendanceDate",
//     },
//     { Text: "Request Type", Value: "RequestTypeName" },
//     {
//       Text: "In Time",
//       Value: "CorrectedInTime",
//       render: (dr) =>
//         dr.CorrectedInTime
//           ? DateTime.fromSQL(dr.CorrectedInTime).toFormat("hh:mm a")
//           : "-",
//     },
//     {
//       Text: "Out Time",
//       Value: "CorrectedOutTime",
//       render: (dr) =>
//         dr.CorrectedOutTime
//           ? DateTime.fromSQL(dr.CorrectedOutTime).toFormat("hh:mm a")
//           : "-",
//     },
//     {
//       Text: "Status",
//       render: (dr) => getStatusBadge(dr.StatusId),
//     },
//     {
//       Text: "Approved By",
//       Value: "ApproverName",
//       render: (dr) => dr.ApproverName || "-",
//     },
//     {
//       Text: "Action",
//       cssClass: "text-center td-width-100",
//       render: (dr) => (
//         <span className="d-flex justify-align-items-center align-items-lg-center">
//           <ActionButton
//             sx={{ color: "#9A9A9A" }}
//             onClick={async () => await viewDetails(dr.RegularizationId)}
//             IconName="View"
//             id="btnView"
//           />
//           {cancelActionVisible(dr) && (
//             <>
//               <ActionButton
//                 onClick={async () => await fnEdit(dr.RegularizationId)}
//                 IconName="Edit"
//                 id="btnEdit"
//               />
//               <button
//                 className="btn btn-default mx-2"
//                 id="btnCancel"
//                 onClick={() => fnCancel(dr.RegularizationId)}
//               >
//                 <i className="fa fa-close"></i>
//               </button>
//             </>
//           )}
//         </span>
//       ),
//     },
//   ];

//   const [bData] = useState([
//     {
//       title: "Attendance Management",
//       hrefLink: "#",
//     },
//     {
//       title: "Attendance Regularization",
//       hrefLink: "#",
//     },
//   ]);

//   const MasterPageName = "Attendance Regularization";
//   const confirmMessage = MasterPageName + " Deleted successfully";
//   const AddButtonText = "Regularization Request";

//   useEffect(() => {
//     if (
//       searchParams.get("action") === "ViewDetails" &&
//       searchParams.get("search") !== null
//     ) {
//       const RegularizationId = parseInt(window.atob(searchParams.get("search")));
//       Promise.all([viewDetails(RegularizationId)]);
//     }
//   }, []);

//   return (
//     <>
//       <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
//       <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />

//       <Container fluid className="base-container">
//         <Box
//           sx={{
//             width: 1,
//             height: 80,
//           }}
//         >
//           <div className="d-flex justify-content-between align-items-center">
//             <div>
//               <h3 className="ms-4 mt-2">{MasterPageName}</h3>
//               <div className="ms-4">
//                 <BreadcrumbsComponent bData={bData}></BreadcrumbsComponent>
//               </div>
//             </div>
//           </div>
//         </Box>
//         <TableComponent
//           columns={columns}
//           data={chain(records)
//             .sortBy((s) => s.RegularizationId)
//             .reverse()
//             .value()}
//           title={AddButtonText}
//           isSearchRequired={true}
//           noRecordCss="p-0"
//           noRecordFound={
//             <NoRecordTemplate
//               headerValue="No Regularization Requests Found"
//               subHeaderValue="You haven't raised any attendance regularization requests yet"
//               imageUrl={StandardConst.imageNoRecordsFound}
//               actionButton={
//                 <>
//                   {permission.ManageAdd && (
//                     <Button
//                       id="NoRecordFoundRaiseRequest"
//                       variant="outline-primary"
//                       onClick={() => fnEdit(0)}
//                     >
//                       Raise {AddButtonText}
//                     </Button>
//                   )}
//                 </>
//               }
//             />
//           }
//           onAddEvent={() => fnEdit()}
//           IsAddButtonVisible={permission?.ManageAdd}
//           allowSerialNo={true}
//           initialSearchContent={searchParams.get("search") ?? ""}
//         />

//         <AddEditAttendanceRegularization
//           callBackEvent={() => fetchRegularizationList()}
//           ref={addEditModalRef}
//         />

//         <ViewRegularizationDetails
//           ref={viewDetailsModalRef}
//         />
//       </Container>
//     </>
//   );
// };

// export default AttendanceRegularizationList;

import React, { useEffect, useState, useRef } from "react";
import { WebService } from "../../Services/WebService";
import AddEditAttendanceRegularization from "./AddEditAttendanceRegularization";
import ViewRegularizationDetails from "./ViewRegularizationDetails";
import Container from "react-bootstrap/Container";
import { useDispatch, useSelector } from "react-redux";
import TableComponent from "../../Services/TableComponent";
import { PageInfo } from "../PageInfo";
import SnackbarComponent from "../../Services/SnackbarComponent";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import Button from "react-bootstrap/Button";
import { NoRecordTemplate } from "../../Services/TableComponent";
import { StandardConst } from "../../Services/StandardConst";
import { Box } from "@mui/material";
import BreadcrumbsComponent from "../../Services/BreadcrumbsComponent";
import { DateTime } from "luxon";
import { chain, map } from "underscore";
import { useSearchParams } from "react-router-dom";
import ActionButton from "../../Services/ActionButton";

const AttendanceRegularizationList = () => {
  const [searchParams] = useSearchParams();
  const ref = useRef();
  const refSnackbar = useRef();
  const [records, setRecords] = useState([]);
  const dispatch = useDispatch();

  PageInfo({ pageTitle: "Attendance Regularization" });

  const [permission, SetPermission] = useState({});
  const permissionList = useSelector((s) => s.auth.PermissionList ?? []);

  const Auth = useSelector((s) => s.auth ?? {});
console.log(permissionList,'Permitions');
  useEffect(() => {
    SetPermission({
      ManageAdd: true,
      ManageEdit: true,
      ManageView: true,
    });
  }, [permissionList]);

  // const fetchRegularizationList = async () => {
  //   try {
  //     // Use the correct endpoint path - notice "Fetch/Own" not "Fetch/:id"
  //     const endPoint = "AttendanceRegularization/Fetch/Own";
      
  //     const data = await WebService({ 
  //       endPoint,
  //       dispatch 
  //     });
      
  //     console.log("✅ API Response:", data); // Debug log
      
  //     // Check if we got the right response structure
  //     if (data && data.AllRequests) {
  //       console.log("✅ Found AllRequests:", data.AllRequests.length, "records");
  //       setRecords(
  //         map(data.AllRequests, (m) => ({
  //           ...m,
  //           EncodedId: window.btoa(m.RegularizationId),
  //         }))
  //       );
  //     } else if (Array.isArray(data)) {
  //       // If response is directly an array
  //       console.log("✅ Found array:", data.length, "records");
  //       setRecords(
  //         map(data, (m) => ({
  //           ...m,
  //           EncodedId: window.btoa(m.RegularizationId),
  //         }))
  //       );
  //     } else {
  //       console.error("❌ Unexpected response structure:", data);
  //       setRecords([]);
  //     }
  //   } catch (error) {
  //     console.error("❌ Error fetching regularization list:", error);
  //     setRecords([]);
  //   }
  // };

  
  
const fetchRegularizationList = async () => {
  try {
    const endPoint = "AttendanceRegularization/Fetch/Own";
    
    const data = await WebService({ 
      endPoint,
      dispatch 
    });
    
    let rawRecords = [];
    
    if (data && data.AllRequests) {
      rawRecords = data.AllRequests;
    } else if (Array.isArray(data)) {
      rawRecords = data;
    } else {
      console.error("❌ Unexpected response structure:", data);
      setRecords([]);
      return;
    }
    
    // Helper function
    const getStatusText = (statusId) => {
      switch (statusId) {
        case 1: return "Pending";
        case 2: return "Approved";
        case 3: return "Rejected";
        case 4: return "Cancelled";
        default: return "Unknown";
      }
    };
    
    const formattedRecords = map(rawRecords, (m) => ({
      ...m,
      EncodedId: m.RegularizationId ? window.btoa(m.RegularizationId) : "",
      
      // Format dates
      RequestDateFormatted: m.RequestDate 
        ? DateTime.fromISO(m.RequestDate).toFormat("dd-MM-yyyy") 
        : "-",
      
      AttendanceDateFormatted: m.AttendanceDate 
        ? DateTime.fromISO(m.AttendanceDate).toFormat("dd-MM-yyyy") 
        : "-",
      
      // Format times
      CorrectedInTimeFormatted: m.CorrectedInTime
        ? DateTime.fromSQL(m.CorrectedInTime).toFormat("hh:mm a")
        : "-",
      
      CorrectedOutTimeFormatted: m.CorrectedOutTime
        ? DateTime.fromSQL(m.CorrectedOutTime).toFormat("hh:mm a")
        : "-",
      
      // Format status
      StatusText: getStatusText(m.StatusId),
      
      // Format other fields
      ApproverNameFormatted: m.ApproverName || "-",
      ApprovalNoteFormatted: m.ApprovalNote || "-",
      RemarksFormatted: m.Remarks || "-",
      
      ApprovedOnFormatted: m.ApprovedOn
        ? DateTime.fromISO(m.ApprovedOn).toFormat("dd-MM-yyyy")
        : "-",
    }));
    
    console.log("✅ Formatted records:", formattedRecords);
    setRecords(formattedRecords);
    
  } catch (error) {
    console.error("❌ Error fetching regularization list:", error);
    setRecords([]);
  }
};

// Helper function to get status text
const getStatusText = (statusId) => {
  switch (statusId) {
    case 1:
      return "Pending";
    case 2:
      return "Approved";
    case 3:
      return "Rejected";
    case 4:
      return "Cancelled";
    default:
      return "Unknown";
  }
};
  const onDelete = async () => {
    await fetchRegularizationList();
  };

  const renderAfterCalled = useRef(false);
  const addEditModalRef = useRef();
  const viewDetailsModalRef = useRef();

  useEffect(() => {
    if (!renderAfterCalled.current) {
      console.log("🔄 Component mounted, fetching list...");
      fetchRegularizationList();
      renderAfterCalled.current = true;
    }
  }, []);

  // const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);

  const fnEdit = async (id) => {
  try {
    console.log("✏️ Edit button clicked, ID:", id);
    console.log("✏️ addEditModalRef:", addEditModalRef.current);
    
    if (addEditModalRef.current && addEditModalRef.current.openModal) {
      await addEditModalRef.current.openModal(id || 0);
    } else {
      console.error("❌ addEditModalRef not ready");
    }
  } catch (error) {
    console.error("❌ Error in fnEdit:", error);
    alert("Error opening edit form: " + error.message);
  }
};

  // const viewDetails = async (id) => await viewDetailsModalRef.current.openModal(id || 0, true);

  const viewDetails = async (id) => {
  try {
    console.log("👁️ View button clicked, ID:", id);
    console.log("👁️ viewDetailsModalRef:", viewDetailsModalRef.current);
    
    if (viewDetailsModalRef.current && viewDetailsModalRef.current.openModal) {
      await viewDetailsModalRef.current.openModal(id || 0, true);
    } else {
      console.error("❌ viewDetailsModalRef not ready");
    }
  } catch (error) {
    console.error("❌ Error in viewDetails:", error);
    alert("Error opening details: " + error.message);
  }
};
   


const formatDate = (dateString, format = "DD-MM-YYYY") => {
  if (!dateString) return "";

  const d = new Date(dateString);
  const iso = d.toISOString().split("T")[0]; // YYYY-MM-DD

  if (format === "YYYY-MM-DD") return iso;

  // Convert to DD-MM-YYYY
  const [y, m, d2] = iso.split("-");
  return `${d2}-${m}-${y}`;
};


const RequestTypes = {
    'Missed Punch': 1,
    'Incorrect Punch': 2,
    'On Duty': 3,
    'Work from Home': 4,
    'Other': 5
  };
const formatTime = (timeString) => {
  if (!timeString) return "";
  return DateTime.fromSQL(timeString).toFormat("hh:mm a");  
};



  const fnCancel = async (id,Rdata) => {
    const data = {
      RegularizationId: id,
      StatusId: StandardConst.RegulrizationStatus.Cancelled,
    };
    await WebService({
      endPoint: "AttendanceRegularization/ChangeStatus",
      body: data,
      dispatch,
    });



    const RequestTypesReverse = Object.fromEntries(
            Object.entries(RequestTypes).map(([key, value]) => [value, key])
          );
            const newData = {
              ...Rdata,                       // copy entire object
              EmployeeName: Auth?.BasicInfo?.FullName || data?.EmployeeName ,  // new field
              // EmployeeName: 'raja',
            
              StatusId:
                'Cancelled',
                  RequestTypeText: RequestTypesReverse[Rdata?.data?.RequestType] || "Unknown",
                  FormattedAttendanceDate: formatDate(Rdata?.data?.AttendanceDate),
                  FormattedRequestDate: formatDate(Rdata?.data?.RequestDate),
      
                  FormattedInTime: formatTime(Rdata?.data?.CorrectedInTime),
                  FormattedOutTime: formatTime(Rdata?.data?.CorrectedOutTime),
                  
            };

            console.log(newData,'MAIL ARRAY')
      

    //on cancel send menager email
    await WebService({
      endPoint: "Email/send-regularization-CancleEmail",
      body: {'data':newData,'employeeID': Rdata?.EmployeeId},
      dispatch,
    });

    fetchRegularizationList();
    };

  const getStatusBadge = (statusId) => {
    // alert(statusId,'hi');
    console.log('hi Shiv',statusId);
    switch (statusId) {
      case 1:
        return <span className="badge bg-warning">Pending</span>;
      case 2:
        return <span className="badge bg-success">Approved</span>;
      case 3:
        return <span className="badge bg-danger">Rejected</span>;
      case 4:
        return <span className="badge bg-secondary">Cancelled</span>;
      default:
        return <span className="badge bg-info">Unknown</span>;
    }
  };


  // const getStatusBadge = (statusId) => {
  //   switch (statusId) {
  //     case 1:
  //       return "Pending";
  //     case 2:
  //       return "Approved";
  //     case 3:
  //       return "Rejected";
  //     case 4:
  //       return "Cancelled";
  //     default:
  //       return "Unknown";
  //   }
  // };


  const cancelActionVisible = (request) => {
    return request.StatusId === StandardConst.RegulrizationStatus.Pending;
  };

  // const columns = [
  //   { Text: "EncodedId", Value: "EncodedId", isVisiable: false },
  //   {
  //     Text: "Request Date",
  //     DateFormat: "yyyy-MM-dd",
  //     Value: "RequestDate",
  //   },
  //   {
  //     Text: "Attendance Date",
  //     DateFormat: "yyyy-MM-dd",
  //     Value: "AttendanceDate",
  //   },
  //   { Text: "Request Type", Value: "RequestTypeName" },
  //   {
  //     Text: "In Time",
  //     Value: "CorrectedInTime",
  //     render: (dr) =>
  //       dr.CorrectedInTime
  //         ? DateTime.fromSQL(dr.CorrectedInTime).toFormat("hh:mm a")
  //         : "-",
  //   },
  //   {
  //     Text: "Out Time",
  //     Value: "CorrectedOutTime",
  //     render: (dr) =>
  //       dr.CorrectedOutTime
  //         ? DateTime.fromSQL(dr.CorrectedOutTime).toFormat("hh:mm a")
  //         : "-",
  //   },
  //   {
  //     Text: "Status",
  //     render: (dr) => getStatusBadge(dr.StatusId),
  //   },
  //   {
  //     Text: "Approved By",
  //     Value: "ApproverName",
  //     render: (dr) => dr.ApproverName || "-",
  //   },
  //   {
  //     Text: "Approver Remark",
  //     Value: "ApprovalNote",
  //     render: (dr) => dr.ApprovalNote || "-",
  //   },
  //   {
  //     Text: "Remark",
  //     Value: "Remarks",
  //     render: (dr) => dr.Remarks || "-",
  //   },
  //   {
  //     Text: "Approver Date",
  //     Value: "ApprovedOn",
  //     // render: (dr) => dr.ApprovedOn || "-",
  //     render: (dr) => {
  //       return dr.ApprovedOn
  //         ? DateTime.fromISO(dr.ApprovedOn).toFormat("dd-MM-yyyy") // or "dd LLL yyyy" → e.g., 11 Nov 2025
  //         : "-";
  //     },
  //   },
  //   {
  //     Text: "Action",
  //     cssClass: "text-center td-width-100",
  //     render: (dr) => (
  //       <span className="d-flex justify-align-items-center align-items-lg-center">
          
  //         <ActionButton
  //           sx={{ color: "#9A9A9A" }}
  //           onClick={async () => await viewDetails(dr.RegularizationId)}
  //           IconName="View"
  //           id="btnView"
  //         />
  //         {cancelActionVisible(dr) && (
            
  //           <>
  //             <ActionButton
  //               onClick={async () => await fnEdit(dr.RegularizationId)}
  //               IconName="Edit"
  //               id="btnEdit"
  //             />
  //             <button
  //               className="btn btn-default mx-2"
  //               id="btnCancel"
  //               onClick={() => fnCancel(dr.RegularizationId)}
  //             >
  //               <i className="fa fa-close"></i>
  //             </button>
  //           </>
  //         )}
  //       </span>
  //     ),
  //   },
  // ];


  // Updated columns definition
const columns = [
  { Text: "EncodedId", Value: "EncodedId", isVisiable: false },
  { Text: "Request Date", Value: "RequestDateFormatted" },
  { Text: "Attendance Date", Value: "AttendanceDateFormatted" },
  { Text: "Request Type", Value: "RequestTypeName" },
  { Text: "In Time", Value: "CorrectedInTimeFormatted" },
  { Text: "Out Time", Value: "CorrectedOutTimeFormatted" },
  { Text: "Status", Value: "StatusText", render: (dr) => getStatusBadge(dr.StatusId) },
  { Text: "Approved By", Value: "ApproverNameFormatted" },
  { Text: "Approver Remark", Value: "ApprovalNoteFormatted" },
  { Text: "Remark", Value: "RemarksFormatted" },
  { Text: "Approver Date", Value: "ApprovedOnFormatted" },
  {
    Text: "Action",
    Value: "Action",
    cssClass: "text-center td-width-100",
    NotUseInExport: true,
    render: (dr) => (
      <span className="d-flex justify-align-items-center align-items-lg-center">
        <ActionButton
          sx={{ color: "#9A9A9A" }}
          onClick={async () => await viewDetails(dr.RegularizationId)}
          IconName="View"
          id="btnView"
        />
        {cancelActionVisible(dr) && (
          <>
            <ActionButton
              onClick={async () => await fnEdit(dr.RegularizationId)}
              IconName="Edit"
              id="btnEdit"
            />
            <button
              className="btn btn-default mx-2"
              id="btnCancel"
              onClick={() => fnCancel(dr.RegularizationId,dr)}
            >
              <i className="fa fa-close"></i>
            </button>
          </>
        )}
      </span>
    ),
  },
];

  const [bData] = useState([
    {
      title: "Attendance Management",
      hrefLink: "#",
    },
    {
      title: "Attendance Regularization",
      hrefLink: "#",
    },
  ]);

  const MasterPageName = "Attendance Regularization";
  const confirmMessage = MasterPageName + " Deleted successfully";
  const AddButtonText = "Regularization Request";

  useEffect(() => {
    if (
      searchParams.get("action") === "ViewDetails" &&
      searchParams.get("search") !== null
    ) {
      const RegularizationId = parseInt(window.atob(searchParams.get("search")));
      Promise.all([viewDetails(RegularizationId)]);
    }
  }, []);

  return (
    <>
      <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
      <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />

      <div className="base-container">
        <Box
          sx={{
            width: 1,
            height: 80,
          }}
        >
          
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h3 className="ms-4 mt-2">{MasterPageName}</h3>
              <div className="ms-4">
                <BreadcrumbsComponent bData={bData}></BreadcrumbsComponent>
              </div>
            </div>
          </div>
        </Box>
        <TableComponent
          columns={columns}
          data={chain(records)
            .sortBy((s) => s.RegularizationId)
            .reverse()
            .value()}
          title={AddButtonText}
          excelExportFileName={"regularization"}
          isSearchRequired={true}
          noRecordCss="p-0"
          noRecordFound={
            <NoRecordTemplate
              headerValue="No Regularization Requests Found"
              subHeaderValue="You haven't raised any attendance regularization requests yet"
              imageUrl={StandardConst.imageNoRecordsFound}
              actionButton={
                <>
                  {permission.ManageAdd && (
                    <Button
                      id="NoRecordFoundRaiseRequest"
                      variant="outline-primary"
                      onClick={() => fnEdit(0)}
                    >
                      Raise {AddButtonText}
                    </Button>
                  )}
                </>
              }
            />
          }
          onAddEvent={() => fnEdit()}
          IsAddButtonVisible={permission?.ManageAdd}
          allowSerialNo={true}
          initialSearchContent={searchParams.get("search") ?? ""}
        />

        <AddEditAttendanceRegularization
          callBackEvent={() => fetchRegularizationList()}
          ref={addEditModalRef}
        />

        <ViewRegularizationDetails
          ref={viewDetailsModalRef}
        />
      </div>
    </>
  );
};

export default AttendanceRegularizationList;